<!--<ng-container *ngIf="layoutContainers">
<ng-container *ngIf="pageAssetContainers$ | async as pageAssetContainers">
  <ng-container *ngFor="let container of layoutContainers">
    <custom-dot-cms-edit-container-wrapper [container]="container">
      <ng-container
        *ngIf="pageAssetContainers[container.identifier]?.contentlets['uuid-' + container.uuid] as contentlets"
        >
        <ng-container *ngFor="let contentlet of contentlets">
          <custom-dot-cms-edit-contentlet-wrapper [contentlet]="contentlet" class="d-block">
            <custom-dot-cms-content-render [contentlet]="contentlet"></custom-dot-cms-content-render>
          </custom-dot-cms-edit-contentlet-wrapper>
        </ng-container>
      </ng-container>

      <custom-dot-cms-contentlet
        [contentlets]="pageAssetContainers[container.identifier].contentlets['uuid-' + container.uuid]"
      ></custom-dot-cms-contentlet>
    </custom-dot-cms-edit-container-wrapper>
  </ng-container>
</ng-container>
</ng-container>-->
@if (layoutContainers()) { @for (container of layoutContainers(); track container) {
<div
  dotCmsContainerEditWrapper
  [ngClass]="{
    'empty-container mt-3 mb-3 card': !container.assignedContentlets?.length && isEditMode,
    'd-block': container.assignedContentlets?.length
  }"
  [container]="container.identifier"
  [uuid]="container.uuid"
>
  <!-- Check if there are any assigned contentlets -->
  @if (!isEditMode || container.assignedContentlets?.length > 0) { @for (assignedContentlet of
  container.assignedContentlets; track assignedContentlet) {
  <!-- Todo: Include container wrapper -->
  @if (assignedContentlet) {
  <div
    dotCmsContentletEditWrapper
    [contentlet]="assignedContentlet.identifier"
    [container]="container.identifier"
    [container_uuid]="container.uuid"
    class="d-block dotcms-contentlet-edit-wrapper"
  >
    <custom-dot-cms-content-render [contentlet]="assignedContentlet" />
  </div>
  } } } @else { This Container is Empty }
  <!-- Template for empty container -->
</div>
} }
